/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RadiologyStudy from './radiology-study';
import RadiologyStudyDetail from './radiology-study-detail';
import RadiologyStudyUpdate from './radiology-study-update';
import RadiologyStudyDeleteDialog from './radiology-study-delete-dialog';

const RadiologyStudyRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RadiologyStudy />} />
    <Route path="new" element={<RadiologyStudyUpdate />} />
    <Route path=":id">
      <Route index element={<RadiologyStudyDetail />} />
      <Route path="edit" element={<RadiologyStudyUpdate />} />
      <Route path="delete" element={<RadiologyStudyDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RadiologyStudyRoutes;
